<template>
	<div :class="{'inline-partial': !isHomePage}" class="profile-partial">
		<div v-if="permissions.isTeamAccount" class="flex justify-end">
			<div class="profile-button-wrap">
				<ProfileButton />
			</div>
		</div>
		<div>
			<nuxt-link :to="{ name: 'login', params: { logout: true } }" class="button-dark">
				{{ $tc('actions.logout') }}
			</nuxt-link>
		</div>
		<language-selector class="ml-10 mt-10 mr-10 mb-10" :active-menu="activeMenu" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import LanguageSelector from '../interface/LanguageSelector'
import { ProfileButton } from '~/components/particles'

export default {
	name: 'ProfilePartial',
	components: { LanguageSelector, ProfileButton },
	props: {
		activeMenu: {
			type: Boolean,
			required: ''
		}
	},
	computed: {
		...mapGetters({ permissions: 'user/permissions' }),

		isHomePage () {
			return this.$route.name === 'profile-my-pixellot'
		}
	}
}
</script>

<style lang="scss">
	@include respond-below(laptop) {
		.profile-button-wrap {
			margin-bottom: 25px;
		}
		.profile-partial {
			background-color: $content-bg;
			padding: 25px 25px 75px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}
	}

	@include respond-above(laptop) {
		.profile-partial {
			margin-bottom: 25px;

			&.inline-partial {
				margin: 0;
				display: flex;
				flex-direction: row-reverse;
				align-items: center;

				.profile-button-wrap {
					margin-bottom: 0;
				}
			}

			.button-dark {
				border-radius: 24px;
				font-size: 21px;
				padding: 10px 25px;
				transition: 0.4s opacity;
				z-index: 15;

				&:hover {
					opacity: 0.8;
				}
			}

			.profile-button-wrap {
				margin-bottom: 25px;
				padding-left: 20px;
				position: relative;
				z-index: 10;

				&::before {
					content: '';
					position: absolute;
					height: 153px;
					width: 110px;
					z-index: -1;
					top: -45px;
					left: 10px;
					background-image: url('/my/images/profile-icon-bg.png');
				}
			}
		}
	}
</style>
